import { render, staticRenderFns } from "./NotificationMessages.vue?vue&type=template&id=5fe6efe3"
import script from "./NotificationMessages.vue?vue&type=script&lang=js"
export * from "./NotificationMessages.vue?vue&type=script&lang=js"
import style0 from "./NotificationMessages.vue?vue&type=style&index=0&id=5fe6efe3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports